// extracted by mini-css-extract-plugin
export default {"particleContainer":"particles_particleContainer__Blpfp","particle":"particles_particle__94QZO"};